import React from "react";
import _ from "lodash";
import { Grid } from "@material-ui/core";
import { InputText, InputTypeAhead, SecondaryButton } from "@loanbossinc/component-library";

import { PaddedWrapper, Row } from "../styles";

import { FieldListItemSelector } from "./fieldListItemSelector";

export const FieldSelector = props => {
  const {
    calculatedFieldFieldsFilter,
    calculatedFieldSearchTerm,
    deal,
    fields,
    onFieldSelectedForCalculation,
    propertyId,
    setCalculatedFieldSelections,
    setFieldSelections
  } = props;

  const onCancelSelectField = () => {
    setFieldSelections({ isSelectingField: false });
    setCalculatedFieldSelections({ calculatedFieldFieldsFilter: "0", calculatedFieldSearchTerm: "", selectedCalculation: null });
  };

  const handleSearch = event => {
    event.persist();
    const handleChangeDebounce = _.debounce(e => {
      if (e.target.value) {
        setCalculatedFieldSelections({ calculatedFieldSearchTerm: e.target.value.toLowerCase() });
      } else {
        setCalculatedFieldSelections({ calculatedFieldSearchTerm: "" });
      }
    }, 500);

    handleChangeDebounce(event);
  };

  const mapFieldsToListItems = fieldList => fieldList.map(field => <FieldListItemSelector key={field.id} deal={deal} field={field} onClick={onFieldSelectedForCalculation} />);

  const getFilteredFields = () => {
    if (!fields) {
      return [];
    }

    let filteredFields = fields.filter(field => {
      // Field is set to Deal and filter is set to All (show deal and hard-coded fields)
      if ((!calculatedFieldFieldsFilter || calculatedFieldFieldsFilter === "0") && propertyId === -1 && (field.level === "deal" || field.level === "all")) {
        return true;
      }

      // Field is set to a specific property and filter is set to All (show hard-coded and property-specific fields)
      if (
        (!calculatedFieldFieldsFilter || calculatedFieldFieldsFilter === "0") &&
        propertyId !== -1 &&
        (field.level === "all" || (Boolean(field.propertyId) && field.propertyId === propertyId))
      ) {
        return true;
      }

      // Filter is set to Hard-coded (show only hard-coded fields)
      if (calculatedFieldFieldsFilter === "-2" && field.level === "all") {
        return true;
      }

      // Field is set to Deal and filter is set to Deal (show only deal fields)
      if (propertyId === -1 && calculatedFieldFieldsFilter === "-1" && field.level === "deal") {
        return true;
      }

      // Field is set to a specific property and filter is set to specific property (show only property-specific fields)
      if (propertyId !== -1 && Boolean(field.propertyId) && field.propertyId === calculatedFieldFieldsFilter) {
        return true;
      }

      return false;
    });

    if (!_.isEmpty(calculatedFieldSearchTerm)) {
      filteredFields = filteredFields.filter((field) => field && field.name && field.name.toLowerCase().includes(calculatedFieldSearchTerm));
    }

    return mapFieldsToListItems(_.sortBy(filteredFields, ["name"]));
  };

  const setFieldsFilter = value => {
    setCalculatedFieldSelections({ calculatedFieldFieldsFilter: value });
  };

  const getFieldFilterOptions = () => {
    const options = [{ id: "0", name: "All fields" }];
    if (propertyId === -1) {
      options.push({ id: "-1", name: "Deal-level fields" });
    }

    options.push({ id: "-2", name: "Hard-coded fields" });

    if (propertyId !== -1) {
      const property = deal.properties.find(x => x.id === propertyId);
      if (property) {
        options.push({ id: propertyId, name: property.name });
      }
    }

    return options;
  };

  return (
    <>
      <Row>
        <Grid container>
          <Grid item xs={5}>
            <PaddedWrapper>
              <InputText
                onChange={handleSearch}
                variant="filled"
                id="search-field-by-name"
                name="search-field-by-name"
                label="Search a field by name"
                fullWidth
              />
            </PaddedWrapper>
          </Grid>
          <Grid item xs={5}>
            <PaddedWrapper padding="0 1em 0 0">
              <InputTypeAhead
                variant="filled"
                id="filter"
                name="filter"
                label="Filter by"
                options={getFieldFilterOptions()}
                displayWith={option => option && option.name}
                setValueWith={option => option && option.id}
                onChange={setFieldsFilter}
                value={calculatedFieldFieldsFilter}
                style={{ width: "auto" }}
              />
            </PaddedWrapper>
          </Grid>
          <Grid item xs={2}>
            <PaddedWrapper padding="0.25em 1em 0 0">
              <SecondaryButton id="cancel-select-field" onClick={onCancelSelectField} label="Cancel" style={{ width: "auto" }} />
            </PaddedWrapper>
          </Grid>
        </Grid>
      </Row>
      {getFilteredFields()}
    </>
  );
};

export default FieldSelector;
